export default {
  state: {
    deviceType: '电脑',
  },
  mutations: {
    setDeviceType(state, type) {
      state.deviceType = type
    },
  },
  actions: {
    setDeviceType({ commit }, type) {
      commit('setDeviceType', type)
    },
  },
  getters: {
    getDeviceType(state) {
      return state.deviceType
    },
  },
}
